<div class="bordered" *ngIf="list.itemCount">
  <div class="table">
    <div class="head-group sticky">
      <div class="row">
        <span *ngIf="!hideColumn('co')" class="cell">
          <sort-by
            [selected]="'socis' === list.filter.sortOrder.sortBy"
            (sort)="onSort('socis', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('co') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('phase')" class="cell">
          <sort-by
            [selected]="'sousek' === list.filter.sortOrder.sortBy"
            (sort)="onSort('sousek', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('phase') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('name')" class="cell">
          <sort-by
            [selected]="'sotx' === list.filter.sortOrder.sortBy"
            (sort)="onSort('sotx', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('name') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('administrator')" class="cell">
          <sort-by
            [selected]="isArray(list.filter.sortOrder) && list.filter.sortOrder[1]?.sortBy === 'detail.administrator.companyName'"
            (sort)="onSort(['detail.administrator.companyName', 'detail.administrator.surname'], $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('administrator') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('state')" class="cell">
          <sort-by
            [selected]="'detail.constructionObjectStatus.name' === list.filter.sortOrder.sortBy"
            (sort)="onSort('detail.constructionObjectStatus.name', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('state') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('coSolution')" class="cell">
          <sort-by
            [selected]="'detail.constructionObjectSolution.name' === list.filter.sortOrder.sortBy"
            (sort)="onSort('detail.constructionObjectSolution.name', $event)"
            [sortDir]="list.filter.sortOrder.direction"
          >{{ getColumnName('coSolution') }}</sort-by>
        </span>

        <span *ngIf="!hideColumn('realizationDate')" class="cell">{{ getColumnName('realizationDate') }}</span>
        <span *ngIf="!hideColumn('mandatary')" class="cell">{{ getColumnName('mandatary') }}</span>
        <span *ngIf="!hideColumn('permanentOccupationState')" class="cell">{{ getColumnName('permanentOccupationState') }}</span>
        <span *ngIf="!hideColumn('overOneYearOccupationState')" class="cell">{{ getColumnName('overOneYearOccupationState') }}</span>
        <span *ngIf="!hideColumn('underOneYearOccupationState')" class="cell">{{ getColumnName('underOneYearOccupationState') }}</span>
        <span *ngIf="!hideColumn('easementCaseState')" class="cell">{{ getColumnName('easementCaseState') }}</span>
      </div>
    </div>
    <div class="row-group">
      <a class="row" *ngFor="let constructionObject of list.list" (click)="onClick(constructionObject)" [uiSref]="clickable ? undefined : 'symap.project.constructionObjects.detail'" [uiParams]="{ id: constructionObject.id, page: null }">
        <span *ngIf="!hideColumn('co')" class="cell" style="white-space: nowrap;">
          {{ constructionObject.socis }} <span *ngIf="constructionObject.geometricalPlanExists" class="badge badge-blue">VB</span>
        </span>
        <span *ngIf="!hideColumn('phase')" class="cell number">{{ constructionObject.sousek }}</span>
        <span *ngIf="!hideColumn('name')" class="cell">{{ constructionObject.sotx }}</span>
        <span *ngIf="!hideColumn('administrator')" class="cell">{{ (constructionObject.administrator?.customer?.rootCustomer || constructionObject.administrator) | projectSubjectName:false:true }}</span>
        <span *ngIf="!hideColumn('state')" class="cell">{{ constructionObject.constructionObjectStatus?.name }}</span>
        <span *ngIf="!hideColumn('coSolution')" class="cell">{{ constructionObject.constructionObjectSolution?.name }}</span>
        <span *ngIf="!hideColumn('realizationDate')" class="cell centered-text">{{ constructionObject.realizationDate | date }}</span>

        <span *ngIf="!hideColumn('mandatary')" class="cell" style="line-height:15px;">
          <span gmtAuthNot="assignment_edit">{{ constructionObject.user | username }}</span>
          <gmt-select
            *ngIf="users"
            gmtAuth="assignment_edit"
            [data]="constructionObject"
            field="user"
            [optionItems]="users"
            [itemPipe]="userNamePipe"
            required="true"
            (click)="$event.preventDefault(); $event.stopPropagation();"
            (changed)="onUpdateUser(constructionObject.id, constructionObject.user.id);"
          ></gmt-select>
          <span [ngStyle]="{visibility: userSending[constructionObject.id] ? 'visible' : 'hidden'}" class="content-loading small-spinner">
              <span class="loader"><span class="loading-spinner"></span></span>
          </span>
        </span>

        <!-- trvale zabory -->
        <span *ngIf="!hideColumn('permanentOccupationState')" class="cell no-padding cell--chart cell-max-height">
          <settlement-progress-chart
            [tooltipType]="'parcels'"
            [tooltipData]="{ occupationResolution: constructionObject.occupationResolution, occupationCategory: 'permanent' }"
            [data]="constructionObject.occupationResolution | settlementCategory: 'permanent'"
          ></settlement-progress-chart>
        </span>

        <!-- docasne zabory nad jeden rok -->
        <span *ngIf="!hideColumn('overOneYearOccupationState')" class="cell no-padding cell--chart cell-max-height">
          <settlement-progress-chart
            [tooltipType]="'parcels'"
            [tooltipData]="{ occupationResolution: constructionObject.occupationResolution, occupationCategory: 'overOneYear' }"
            [data]="constructionObject.occupationResolution | settlementCategory: 'overOneYear'"
          ></settlement-progress-chart>
        </span>

        <!-- docasne zabory do jednoho roku -->
        <span *ngIf="!hideColumn('underOneYearOccupationState')" class="cell no-padding cell--chart cell-max-height">
          <settlement-progress-chart
            [tooltipType]="'parcels'"
            [tooltipData]="{ occupationResolution: constructionObject.occupationResolution, occupationCategory: 'underOneYear' }"
            [data]="constructionObject.occupationResolution | settlementCategory: 'underOneYear'"
          ></settlement-progress-chart>
        </span>

        <!-- vecna bremena -->
        <span *ngIf="!hideColumn('easementCaseState')" class="cell no-padding cell--chart cell-max-height">
          <settlement-progress-chart
            tooltipType="easements"
            [tooltipData]="{ occupationResolution: constructionObject.occupationResolution, occupationCategory: 'easement' }"
            [data]="constructionObject.occupationResolution | settlementCategory: 'easement'"
          ></settlement-progress-chart>
        </span>
      </a>
    </div>
  </div>
</div>
